import { ChatPane } from "components/ChatPane/ChatPane";
import Slider from "components/DesignSystem/Slider/Slider";
import { useMemo } from "react";
import { useChatContext } from "stream-chat-react";
import { ModalProps } from "types/utils/modal";

export const AgentChatActionSlider = ({
  isOpen,
  close,
  channelId,
  messageId,
}: ModalProps & {
  channelId: string;
  messageId?: string;
}) => {
  const { client } = useChatContext();

  const filter = useMemo(
    () => ({
      type: "messaging",
      members: { $in: [client.userID!] },
      needs_reply: true,
    }),
    [client.userID]
  );

  return (
    <Slider.Root open={isOpen} onOpenChange={close}>
      <Slider.Content open={isOpen}>
        <ChatPane
          channelId={channelId}
          setChannelId={() => {}}
          canGoback={false}
          messageId={messageId}
        />
      </Slider.Content>
    </Slider.Root>
  );
};
